import { render, staticRenderFns } from "./ManufactureProductSpecsModal__Style#Drawer.vue?vue&type=template&id=3a4169e1&scoped=true&"
import script from "./ManufactureProductSpecsModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./ManufactureProductSpecsModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./ManufactureProductSpecsModal__Style#Drawer.vue?vue&type=style&index=0&id=3a4169e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4169e1",
  null
  
)

export default component.exports